module.exports = __webpack_public_path__ + "static/sylwiawork5-723c07b29e784dc910da1d9eebf6a7b6.jpg";